import React from 'react'

const AllLocations = () => {
    return <div></div>
}

export default AllLocations
